<template>
    <div class="w-full bg-background-basic-1">
        <table class="w-full table-fixed">
            <thead>
                <tr>
                    <th scope="col" class="h-14 break-words border-b border-border-basic-2 bg-background-basic-2 p-2 text-center font-caption-md-semibold text-content-basic-2">Cut off</th>
                    <th scope="col" class="h-14 break-words border-b border-border-basic-2 bg-background-basic-2 p-2 text-center font-caption-md-semibold text-content-basic-2">Working Day</th>
                    <th scope="col" class="h-14 break-words border-b border-border-basic-2 bg-background-basic-2 p-2 text-center font-caption-md-semibold text-content-basic-2">Basic Daily Wage</th>
                    <th scope="col" class="h-14 break-words border-b border-border-basic-2 bg-background-basic-2 p-2 text-center font-caption-md-semibold text-content-basic-2">Basic Hourly Wage</th>
                    <th scope="col" class="h-14 break-words border-b border-border-basic-2 bg-background-basic-2 p-2 text-center font-caption-md-semibold text-content-basic-2">Regular Basic</th>
                </tr>
            </thead>
            <tbody class="bg-background-basic-1">
                <tr v-for="(detail, index) in basicSalaryDetailList" v-bind:key="index">
                    <td class="h-16 break-words p-2 text-center font-body-sm-regular text-content-basic-1">{{ detail.startDate }} - {{ detail.endDate }}</td>
                    <td class="h-16 break-words p-2 text-center font-body-sm-regular text-content-basic-1">{{ detail.workingDayCount }} Days</td>
                    <td class="h-16 break-words p-2 text-center font-body-sm-regular text-content-basic-1">{{ fitDecimalFormatWithComma(detail.dailyWageAmount, 5) }}</td>
                    <td class="h-16 break-words p-2 text-center font-body-sm-regular text-content-basic-1">{{ fitDecimalFormatWithComma(detail.hourlyWageAmount, 5) }}</td>
                    <td class="h-16 break-words p-2 text-center font-body-sm-regular text-content-basic-1">{{ fitDecimalFormatWithComma(detail.workingDayCount * detail.dailyWageAmount, 5) }}</td>
                </tr>
            </tbody>
        </table>
        <div class="flex w-full items-center justify-end gap-3 border-t border-border-basic-2 bg-background-basic-1 px-6 pb-8 pt-6 font-body-md-regular whitespace-nowrap">
            <p class="text-content-basic-2">Total Regular Basic :</p>
            <p class="font-body-md-semibold text-primary-3">{{ fitDecimalFormatWithComma(getTotalRegularBasic()) }}</p>
        </div>
    </div>
</template>

<script>
import { NumberFormatUtil, DateFormatUtil} from "@/plugins/app-util";

export default {
    components :{
    },
    emits : ['update:modelValue', 'afterClose'],
    props : {
        modelValue : Boolean,
        basicSalaryDetailList : Array
    },
    data(){
        return {
        }
    },
    mounted() {
    },
    methods : {
        hidePopup() {
            const self = this;
            self.$emit('update:modelValue', false);
            self.$emit('afterClose');
        },
        getTotalRegularBasic() {
            const self = this;
            let total = 0;
            self.basicSalaryDetailList.forEach(basicSalaryDetail => {
                total += basicSalaryDetail.workingDayCount * basicSalaryDetail.dailyWageAmount;
            });

            return total;
        },
        fitDecimalFormatWithComma : NumberFormatUtil.fitDecimalFormatWithComma,
        fitDateFormat : DateFormatUtil.fitDateFormat
    }
}
</script>